/*
  CTX staged filter application
  Collection and search share one filter form contract. Filter selections are
  intentionally local until the shopper chooses Apply, preventing a page reload
  after every checkbox change.
*/
(function () {
  'use strict';

  function toArray(value) {
    return Array.prototype.slice.call(value || []);
  }

  function selectedControlCount(form) {
    var count = form.querySelectorAll('input[type="checkbox"]:checked').length;
    toArray(form.querySelectorAll('input[type="range"][name]')).forEach(function (input) {
      if ((input.name.endsWith('.gte') && input.value !== input.min) || (input.name.endsWith('.lte') && input.value !== input.max)) count += 1;
    });
    return count;
  }

  function setActionState(form) {
    var count = selectedControlCount(form);
    var countEl = form.querySelector('[data-ctx-filter-selection-count]');
    var apply = form.querySelector('[data-ctx-filter-apply]');
    if (countEl) countEl.textContent = count ? (count + (count === 1 ? ' filter selected' : ' filters selected')) : 'Select filters, then apply';
    if (apply) apply.disabled = false;
  }

  function addFormValues(url, form) {
    var formNames = {};
    toArray(form.elements).forEach(function (element) {
      if (element.name) formNames[element.name] = true;
    });
    Object.keys(formNames).forEach(function (name) { url.searchParams.delete(name); });

    toArray(form.querySelectorAll('input[type="range"][name]')).forEach(function (input) {
      input.disabled = (input.name.endsWith('.gte') && input.value === input.min) || (input.name.endsWith('.lte') && input.value === input.max);
    });

    new FormData(form).forEach(function (value, name) {
      if (value !== '') url.searchParams.append(name, value);
    });

    toArray(form.querySelectorAll('input[type="range"][name]')).forEach(function (input) { input.disabled = false; });
  }

  function applyForm(form) {
    var url = new URL(form.action || window.location.pathname, window.location.origin);
    var current = new URL(window.location.href);
    current.searchParams.forEach(function (value, name) {
      if (!name.startsWith('filter.') && name !== 'page' && name !== 'sort_by') url.searchParams.append(name, value);
    });
    addFormValues(url, form);
    url.searchParams.delete('page');
    document.dispatchEvent(new CustomEvent('ctx:filters:apply', { bubbles: true }));
    window.location.assign(url.toString());
  }

  function init(form) {
    if (!form || form.dataset.ctxApplyBound) return;
    form.dataset.ctxApplyBound = 'true';

    form.addEventListener('change', function () { setActionState(form); });
    form.addEventListener('input', function () { setActionState(form); });
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      applyForm(form);
    });

    var sidebar = form.closest('.ctx-cg__sidebar');
    toArray((sidebar || form).querySelectorAll('[data-ctx-filter-reset]')).forEach(function (reset) {
      reset.addEventListener('click', function () {
        toArray(form.querySelectorAll('input[type="checkbox"]')).forEach(function (input) { input.checked = false; });
        toArray(form.querySelectorAll('input[type="range"][name]')).forEach(function (input) {
          input.value = input.name.endsWith('.gte') ? input.min : input.max;
          var numberInput = document.getElementById(input.dataset.numid || '');
          if (numberInput) numberInput.value = input.value;
          input.dispatchEvent(new Event('input', { bubbles: true }));
        });
        setActionState(form);
      });
    });

    setActionState(form);
  }

  function boot() {
    toArray(document.querySelectorAll('.ctx-cg__filter-form')).forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  if (window.MutationObserver) new MutationObserver(boot).observe(document.documentElement, { childList: true, subtree: true });
})();
